import { useAuthContext } from '../contexts/auth-context';

interface ShopDetails {
	shopId: string;
	locationId: string;
	shopName: string;
	locationName: string;
	businessType: string;
	/** True when the active location sells food rather than salon services. */
	isRestaurant: boolean;
}

export function useShopDetails(): ShopDetails {
	let { shopId, locationId } = useAuthContext();

	if (!shopId) {
		shopId = localStorage.getItem('shopId')!;
	}

	if (!locationId) {
		locationId = localStorage.getItem('locationId')!;
	}

	const shopName = localStorage.getItem('shopName') || 'Hairways';
	const locationName = localStorage.getItem('locationName') || '';
	// A session started before this field existed has nothing stored; treating
	// that as SALON keeps the portal exactly as it was until the next switch.
	const businessType = localStorage.getItem('businessType') || 'SALON';

	return {
		shopId,
		locationId,
		shopName,
		locationName,
		businessType,
		isRestaurant: businessType === 'FOOD_DELIVERY'
	};
}